import {Button} from "react-bootstrap";
import React, {Component} from "react";
import './ClientDataExport.scss';
import * as actions from "./ClientDataExportApi";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";

class ClientDataExport extends Component {
    render() {
        const {client} = this.props;

        return (
            <div className="client-data-export">
                <Button onClick={() => this.props.actions.downloadClientData(client.id, client.name)}>Export
                    data</Button>
                <Button onClick={() => this.props.actions.downloadClientImages(client.id, client.name)}>Export
                    images</Button>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {actions: bindActionCreators(actions, dispatch)}
}

export default connect(null, mapDispatchToProps)(ClientDataExport);
